import React from 'react';
import { VariationNode } from '@/types/variationChain.types';
import { VariationCard } from './VariationCard';

interface VariationTreeProps {
  nodes: VariationNode[];
  onRate: (nodeId: string, rating: number) => void;
  onEvolve: (nodeId: string) => void;
  depth?: number;
}

export const VariationTree: React.FC<VariationTreeProps> = ({ nodes, onRate, onEvolve, depth = 0 }) => {
  if (!nodes || nodes.length === 0) return null;

  return (
    <div className={`space-y-3 ${depth > 0 ? 'ml-6 pl-4 border-l-2 border-slate-800/50' : ''}`}>
      {nodes.map((node, i) => (
        <div key={node.id}>
          <VariationCard
            node={node}
            onRate={onRate}
            onEvolve={onEvolve}
            isRoot={depth === 0 && i === 0 && !node.parentNodeId}
          />
          {node.children && node.children.length > 0 && (
            <VariationTree
              nodes={node.children}
              onRate={onRate}
              onEvolve={onEvolve}
              depth={depth + 1}
            />
          )}
        </div>
      ))}
    </div>
  );
};
